import React from 'react';
import {Button, Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';

import medicalAppointmentImg from 'presentation/assets/images/medical-appointment.svg';
import {MyPaymentsEnum} from 'presentation/constants';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';

import {ImageContainer, StyledCard} from './styles';

const {emptyState} = translations['pt-br'].privateFlow.myFinancial.openBills;

export function OpenBillsEmptyState() {
	const navigate = useNavigate();
	const {isMobile} = useMediaQueries();

	return (
		<StyledCard elevation={0}>
            <Stack display="flex" flexDirection={isMobile ? 'column' : 'row'} alignItems="center" justifyContent="center">
			<Stack width={isMobile ? '100%' : "400px"}>
				<Typography variant="h6" textAlign={isMobile ? 'center' : 'left'}>{emptyState.title}</Typography>
				<Typography color="text.primary" mt={0.5} textAlign={isMobile ? 'center' : 'left'}>
					{emptyState.description}
				</Typography>
				<Stack mt={2}>
					<Button
						variant="contained"
						size="large"
						onClick={() => navigate(MyPaymentsEnum.PAYMENTS_HISTORY)}>
						{emptyState.action}
					</Button>
				</Stack>
			</Stack>
			<ImageContainer sx={{mt: isMobile ? 2 : 0}}>
				<img src={medicalAppointmentImg} alt={emptyState.title} />
			</ImageContainer>
            </Stack>
		</StyledCard>
	);
}
